module.exports = __webpack_public_path__ + "static/media/dishicon.ccb23981.png";